import React from "react"
import { ApiForm } from "components/Common/Form"
import { fields } from "./fields"
import PropTypes from "prop-types"

export function TreeCommentDetail(props) {
  return (
    <ApiForm
      name="edit tree comment"
      mode="edit"
      data={props.data}
      fields={fields}
      onSubmit={props.handleSubmit}
      submitButtonText="Save"
    />
  )
}

TreeCommentDetail.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    hidden: PropTypes.bool,
  }),
  handleSubmit: PropTypes.func,
}
